import styled from 'styled-components'

export const TopBar = styled.div`
  width: 100%;
  height: 64px;
  background: var(--yrm-chrome-bg);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  border-bottom: 1px solid var(--yrm-chrome-borda);
  box-shadow: none;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;

  @media (max-width: 768px) {
    padding: 0 16px;
  }

  @media (max-width: 480px) {
    height: 56px;
    padding: 0 12px;
  }
`

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 0; /* allow children to shrink on small screens */
`

export const MobileMenuButton = styled.button`
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
  }

  @media (min-width: 769px) {
    display: none;
  }
`

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  flex: none;
  
  img {
    height: 36px;
    width: auto;

    @media (max-width: 768px) {
      height: 32px;
    }
    /* celular pequeno: logo menor para caber com a lupa, o + e o sino */
    @media (max-width: 430px) {
      height: 26px;
    }
  }
`

export const SearchContainer = styled.div`
  position: relative;
  max-width: 520px;
  flex: 1;
  transition: all 0.2s ease;

  ${props => props.$focused && `
    transform: scale(1.02);
  `}

  @media (max-width: 768px) {
    max-width: none;
    flex: 1;
    margin: 0 8px;
    
    ${props => props.$focused && `
      transform: none; /* Remove scale no mobile */
    `}
  }

  /* ensure search can shrink and avoid overflow */
  min-width: 0;
  flex-shrink: 1;

  @media (max-width: 480px) {
    margin: 0 6px;
  }

  /* celular: o campo não cabe ao lado dos botões; vira a lupa (BotaoBusca)
     e, aberto, ocupa o topo inteiro por cima dos botões */
  @media (max-width: 600px) {
    display: ${(p) => (p.$aberta ? 'flex' : 'none')};
    position: fixed;
    inset: 0 0 auto 0;
    height: 64px;
    margin: 0;
    padding: 0 8px 0 12px;
    align-items: center;
    gap: 6px;
    background: var(--yrm-chrome-bg);
    z-index: 1100;

    > div:first-child { left: 24px; }
  }
  @media (max-width: 480px) {
    height: 56px;
  }
`

export const BotaoBusca = styled.button`
  display: none;
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  align-items: center;
  justify-content: center;

  &:hover { background: rgba(255, 255, 255, 0.08); }
  @media (max-width: 600px) { display: inline-flex; }
`

export const FecharBusca = styled(BotaoBusca)`
  flex: none;
`

export const SearchResultsDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--yrm-surface);
  border: 1px solid var(--yrm-border);
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  z-index: 1001;
  max-height: 400px;
  overflow: hidden;
  margin-top: 4px;

  @media (max-width: 480px) {
    left: 8px;
    right: 8px;
    max-width: calc(100vw - 32px);
  }
`

export const SearchTabs = styled.div`
  display: flex;
  border-bottom: 1px solid var(--yrm-border);
  background: var(--yrm-surface-2);
  overflow-x: auto;
  scrollbar-width: thin;
`

export const SearchTab = styled.div`
  flex: 1 0 auto;
  padding: 12px 10px;
  text-align: center;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: ${props => props.active ? 'var(--yrm-heading)' : 'var(--yrm-text-3)'};
  background-color: ${props => props.active ? 'var(--yrm-surface)' : 'transparent'};
  border-bottom: ${props => props.active ? '2px solid var(--yrm-heading)' : '2px solid transparent'};
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;

  &:hover {
    color: var(--yrm-heading);
    background-color: ${props => props.active ? 'var(--yrm-surface)' : 'var(--yrm-surface-3)'};
  }

  &:first-child {
    border-radius: 8px 0 0 0;
  }

  &:last-child {
    border-radius: 0 8px 0 0;
  }
`

export const SearchTabContent = styled.div`
  max-height: 350px;
  overflow-y: auto;
`

export const SearchResultsSection = styled.div`
  &:not(:last-child) {
    border-bottom: 1px solid var(--yrm-surface-3);
  }
`

export const SearchResultsTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px 8px;
  font-size: 12px;
  font-weight: 600;
  color: var(--yrm-text-3);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: var(--yrm-surface-2);
  
  &:first-child {
    border-radius: 8px 8px 0 0;
  }
`

export const SearchResultItem = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.2s ease;
  
  &:hover {
    background: var(--yrm-surface-3);
  }
  
  &:last-child {
    border-radius: 0 0 8px 8px;
  }
`

export const SearchResultMain = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: var(--yrm-text);
  margin-bottom: 2px;
`

export const SearchResultSub = styled.div`
  font-size: 12px;
  color: var(--yrm-text-3);
`

export const NaturezaTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: ${p => p.$bg || 'var(--yrm-tint-azul)'};
  color: ${p => p.$color || '#0b64b0'};
  font-size: 12px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 999px;
  border: 1px solid ${p => p.$border || '#3da5ff33'};
  box-shadow: 0 2px 4px ${p => p.$shadow || 'rgba(61,165,255,0.18)'};
  text-transform: uppercase;
  letter-spacing: .6px;
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  backdrop-filter: blur(2px);
  transition: all .25s ease;

  &:hover {
    box-shadow: 0 3px 6px ${p => p.$hoverShadow || 'rgba(61,165,255,0.28)'};
    border-color: ${p => p.$hoverBorder || '#3da5ff66'};
  }
`

export const EmptySearchResults = styled.div`
  padding: 24px 16px;
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
`

export const SearchIcon = styled.div`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  pointer-events: none;

  @media (max-width: 768px) {
    left: 10px;
    
    svg {
      width: 16px;
      height: 16px;
    }
  }
  @media (max-width: 480px) {
    left: 8px;
  }
`

export const SearchInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 0 16px 0 44px;
  border: 1px solid var(--yrm-busca-borda);
  border-radius: 8px;
  font-size: 14px;
  color: var(--yrm-busca-texto);
  background: var(--yrm-busca-bg);
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    background: var(--yrm-busca-bg);
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }

  min-width: 0; /* allow proper shrinking inside flex */

  @media (max-width: 768px) {
    height: 36px;
    font-size: 13px;
    padding: 0 12px 0 36px;
    
    &::placeholder {
      font-size: 13px;
    }
  }
`

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    gap: 8px;
  }
`

export const ActionButtonContainer = styled.div`
  position: relative;
`

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  border: none;
  background: #d6a93a;
  color: #13143A;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #e2bb55;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(214, 169, 58, 0.3);
  }

  @media (max-width: 768px) {
    width: 40px;
    min-width: 40px;
    padding: 0;
    gap: 0;
    justify-content: center;

    span {
      display: none;
    }
  }
`

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: var(--yrm-surface);
  border: 1px solid var(--yrm-border);
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  z-index: 50;
  min-width: 160px;
`

export const DropdownItem = styled.button`
  width: 100%;
  padding: 12px 16px;
  text-align: left;
  border: none;
  background: transparent;
  color: var(--yrm-text);
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: var(--yrm-surface-3);
  }

  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:last-child {
    border-radius: 0 0 8px 8px;
  }
`

export const NotificationButton = styled.button`
  position: relative;
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #cbd5e1;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
  }
`

export const NotificationBadge = styled.span`
  position: absolute;
  top: -2px;
  right: -2px;
  background: #ff0000;
  color: white;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 12px;
  font-weight: 600;
  min-width: 16px;
  text-align: center;
  line-height: 1.2;
  border: 1px solid white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
`

export const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;


  svg {
    color: #6b7280;
  }
`

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const UserName = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  line-height: 1.2;
`

export const UserRole = styled.span`
  font-size: 12px;
  color: #6b7280;
  line-height: 1.2;
`

// Botão redondo e discreto do topo (modo claro/escuro)
export const IconeTopo = styled.button`
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #fff;
  cursor: pointer;
  font-size: 20px;
  transition: background 0.15s ease;

  &:hover { background: rgba(255, 255, 255, 0.12); }
  &:focus-visible { outline: 2px solid #d6a93a; outline-offset: 2px; }
`
